var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowLeft24Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M12.389 16.921a.75.75 0 0 1-1.06-.032l-6-6.375a.75.75 0 0 1 0-1.028l6-6.375a.75.75 0 0 1 1.092 1.028L6.905 10l5.516 5.861a.75.75 0 0 1-.032 1.06",
  clipRule: "evenodd"
})));
export default SvgIconArrowLeft24Px;